/* eslint-disable jsx-a11y/no-onchange */
/** @jsx jsx */
import { bool, string, func } from 'prop-types'
import { jsx, Label, Text } from 'theme-ui'
import './formInputs.css'
import { Check } from '../../../icons/index'

const Checkbox = ({
  checked,
  disabled,
  onChange,
  value,
  label,
  trackingCategory,
  trackingId,
  ...props
}) => {
  return (
    <Label
      sx={{
        position: 'relative',
        pl: 30,
        cursor: 'pointer',
        userSelect: 'none',
      }}
      {...props}
    >
      <input
        type="checkbox"
        checked={checked}
        disabled={disabled}
        onChange={onChange}
        // data attributes used for GTM/GA analytics tracking
        data-track={trackingId}
        data-track-category={trackingId && trackingCategory}
        data-track-value={trackingId && label}
        value={value}
        sx={{
          // hide the native checkbox with opacity so click handlers still work
          position: 'absolute',
          opacity: 0,
          cursor: 'pointer',
          height: 0,
          width: 0,
        }}
      />
      <span
        sx={{
          // custom styled checkbox that replaces the hidden <input type="checkbox">
          position: 'absolute',
          top: 0,
          left: 0,
          height: 20,
          width: 20,
          bg: 'paleSilver',
          border: !checked ? '1px solid #979491' : undefined,
        }}
      >
        {checked ? <Check /> : null}
      </span>
      <Text
        variant="xSmallText"
        sx={{ color: disabled && 'muted', maxWidth: 200 }}
      >
        {label}
      </Text>
    </Label>
  )
}

Checkbox.propTypes = {
  checked: bool,
  disabled: bool,
  onChange: func,
  value: string,
  label: string,
  trackingCategory: string,
  trackingId: string,
}

export default Checkbox
